<template>
  <VDraftCarManagerTable />
</template>
<script>
import VDraftCarManagerTable from '@/components/CarManager/VDraftCarManagerTable.vue'
export default {
  name: 'DraftCarManager',

  components: {
    VDraftCarManagerTable
  }
}
</script>
